export default "__VITE_ASSET__BxPNQTQh__"